import { FC } from 'react';
import type { MoveGrade } from '@whitesharx/starfall-frontend-chessground';
import { SAN } from '@whitesharx/starfall-frontend-core';
import { colorStyles } from '../../styles.css';

const COLORFUL_GRADES: MoveGrade[] = ['best', 'slip', 'mistake', 'blunder'];

const ColorfulSAN: FC<Parameters<typeof SAN>[0]> = ({ grade, ...props }) => {
  const colorfulGrade = grade && COLORFUL_GRADES.includes(grade) ? grade : undefined;

  return <SAN {...props} grade={grade} className={colorfulGrade && colorStyles[colorfulGrade]} />;
};

export default ColorfulSAN;
